import React from 'react';
import ReactDOM from 'react-dom'
import Header from '../../component/header'
import GTip from '../../component/gTip'
import FloatMenu from '../../component/floatMenu'
import { AppContext, defaultState } from '../../config/context'
import '../../common/util/channel'
import '../../common/util/polyfill'
import initReportEnv from '../../common/util/report'

initReportEnv('常见问题')

class App extends React.Component {
    constructor() {
        super()
        this.updateUserInfo = user => {
            this.setState(state => ({
                user: {
                    ...state.user,
                    ...user
                }
            }))
        }
        this.state = {
            ...defaultState,
            updateUserInfo: this.updateUserInfo
        }
    }

    render() {
        return <AppContext.Provider value={this.state}>
            <Header></Header>
            <GTip></GTip>
            <FloatMenu></FloatMenu>
        </AppContext.Provider>
    }
}

ReactDOM.render(<App />, document.getElementById('dokodemodoa'))